/**
 * Caselaw Storage Field Identifiers
 *
 * Central definition for caselaw metadata storage fields to ensure consistency
 * across the application.
 *
 * 📦 Storage Path Fields (why there are multiple):
 * - s3_dir:    Modern standard (used by Assistant BE)
 * - s3_path:   Legacy field (used by old research/caselaw features)
 *
 * 📜 History: LRR used s3_dir, Caselaw used s3_path. When research integrated into
 * Assistant, s3_dir became the standard (more accurate - paths are directories).
 *
 * Priority Order: s3_dir (modern/Assistant) → s3_path (legacy)
 */
export enum CaselawStorageField {
  S3_DIR = 's3_dir', // Modern (Assistant BE)
  S3_PATH = 's3_path', // Legacy (old research/caselaw features)
}

/**
 * Type for caselaw identifier field names
 */
export type CaselawIdentifierType = CaselawStorageField.S3_DIR | CaselawStorageField.S3_PATH

/**
 * Checks if the idType is a valid caselaw identifier type
 * @param idType - The idType to check
 * @returns true if the idType is a valid caselaw identifier type, false otherwise
 */
export function isValidCaselawIdentifierType(idType: string): boolean {
  return Object.values(CaselawStorageField).includes(idType as CaselawStorageField)
}
